import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ai_cover_video_up",
  "use": "icon-ai_cover_video_up-usage",
  "viewBox": "0 0 8 7",
  "content": "<symbol viewBox=\"0 0 8 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ai_cover_video_up\">\n<path d=\"M3.13397 0.500001C3.51887 -0.166666 4.48113 -0.166667 4.86603 0.5L7.4641 5C7.849 5.66667 7.36788 6.5 6.59808 6.5H1.40192C0.632124 6.5 0.150998 5.66667 0.535898 5L3.13397 0.500001Z\" fill=\"#989898\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol